module.exports = __webpack_public_path__ + "static/media/3-d.b2db0c26.png";